export default __webpack_public_path__ + "static/media/arch.4e413b79.svg";